import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/HorizontalNavigation/HorizontalNavigation.js'
import WebComponent from '../../WebComponent.js'
import Navigation from './Navigation.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter.js'

export default class HorizontalNavigation extends WebComponent {

  get translationFile() {
    return './views/Navigation/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.navigationListener = _ => {
      this.reload()
    }
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
    this.render()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  getTemplate() {
    const items = [
      {
        text: this.i18n.translate('navigation.cockpit'),
        url: 'Cockpit',
        active: true
      },
      {
        text: this.i18n.translate('navigation.verbrauch'),
        url: 'Verbrauch',
        suburls: [
          'Verbrauch_Ch',
          'Verbrauch_Chot',
          'Verbrauch_Dch',
          'Verbrauch_Gaznat',
          'Verbrauch_Ail',
          'Verbrauch_Ego',
          'Verbrauch_Egz',
          'Verbrauch_Gvm'
        ]
      },
      {
        text: this.i18n.translate('navigation.gas'),
        url: 'Gas'
      },
      {
        text: this.i18n.translate('navigation.massnahmen'),
        url: 'Massnahmen',
        suburls: [
          'Massnahmen_Dch',
          'Massnahmen_Chot',
          'Massnahmen_Gaznat',
          'Massnahmen_Ail'
        ]
      },
      {
        text: AuthorizationFilter._hasRoleAdmin() ? this.i18n.translate('navigation.admin') : this.i18n.translate('navigation.stammdaten'),
        url: 'Admin',
        suburls: [
          'Admin_Parameter',
          'Admin_Ml',
          'Admin_Tek',
          'Admin_Gek',
          'Admin_Angebot_Ego',
          'Admin_Angebot_Egz',
          'Admin_Angebot_Gaznat',
          'Admin_Angebot_Gvm',
          'Admin_Angebot_Ail',
          'Admin_Seg',
          'Admin_Monitoring',
          'Admin_Export',
          'Admin_Audit'
        ]
      }
    ]
      .filter(i => AuthorizationFilter.viewAllowed(i.url))

    return html`
      <isceco-horizontal-navigation .items="${items}">
      </isceco-horizontal-navigation>
    `
  }
}
customElements.define('gasmonitoring-frontend-horizontal-navigation', HorizontalNavigation)
